export const FinSobValidationPopupTranslations = {
  /**
   * Please, confirm changes
   */
  dialogHeader: 'jbp-planning-check-dialog-header',
  /**
   * Please, confirm changes {inputIndex} of {inputCount}
   */
  dialogNavHeader: 'jbp-planning-check-dialog-nav-header',

  /**
   * {category} {currentValueType} value seems potentially incorrect.
   * {currentValuePeriod} [currentInput.Value]
   */
  title: 'jbp-planning-check-title',
  subTitle: 'jbp-planning-check-subTitle',

  /**
   * Difference {key} [compareTo.diff] [compareTo.Period] [compareTo.Value]
   *
   * Keys:
   *
   * SoB:
   * jbp-planning-check--fy-prev-fq         to the previous quarter
   * jbp-planning-check--fy--fq             to the same quarter Actuals
   * jbp-planning-check-prev-fy--fq         to the same quarter previous year
   *
   * Financial:
   * jbp-planning-check-prev-fy--fq         to the same quarter previous year Actuals
   * jbp-planning-check-prev-fy-average-fq  to the quarterly average Actuals for the previous year
   */
  compareToDiff: 'jbp-planning-check-compareTo-diff',

  /**
   * The given SOB value seems too low based on the revenue. Please provide justification.
   */
  shareOfRevenueError: 'jbp-planning-check-share-of-revenue',

  /**
   * Are you sure these numbers are correct?
   */
  confirmationQuestion: 'jbp-planning-check-are-you-sure',
  /**
   * Are you sure these numbers are correct? If yes, please put a brief justification below.
   */
  justificationQuestion: 'jbp-planning-check-justification-title',

  justificationMessagePlaceholder: 'Add Justification',
  justificationMessagePlaceholderKey: 'jbp-planning-check-justification-placeholder',

  /**
   * You need to confirm {needsToConfirm} of {totalChanges} changes.
   */
  changesToConfirm: 'jbp-planning-check-changes-to-confirm',

  next: 'jbp-planning-check-next',
  prev: 'jbp-planning-check-prev',

  /**
   * Confirm
   */
  confirm: 'jbp-planning-check-confirm',
  confirmed: 'jbp-planning-check-confirmed',
  save: 'jbp-planning-check-save',
  /**
   * Go back to edit
   */
  cancel: 'jbp-planning-check-cancel',
}

export default FinSobValidationPopupTranslations
